export default "__VITE_ASSET__Dct2PsRV__"